module.exports = __webpack_public_path__ + "img/visa.0d04dacf2469e5b0eb36a272585fe814.svg";